// extracted by mini-css-extract-plugin
export default {"SchemasList":"SchemasList_SchemasList__I+iJj"};